module.exports = __webpack_public_path__ + "img/test-connection-empty.72357786.svg";